import { Flex, Text, UnstyledButton } from '@mantine/core'
import { useTranslations } from 'next-intl'

import RefreshIcon from '@/assets/icons/refresh.svg'
import { AllAvailableCurrencyCodes } from '@/types/currency'
import { currencySymbolMap } from '@/utils/number'
import { formatPrice } from '@/utils/number/format'

interface RateDisplayProps {
  coinSymbol: string
  coinName: string
  currency: AllAvailableCurrencyCodes
  rate: number
  isRefreshing: boolean
  onRefresh: () => void
}

export function RateDisplay({
  coinSymbol,
  coinName,
  currency,
  rate,
  isRefreshing,
  onRefresh,
}: RateDisplayProps) {
  const tConverter = useTranslations('converter')
  const currencySymbol = currencySymbolMap[currency] || ''
  return (
    <Flex direction="column" gap={8}>
      <Flex align="center" gap={8} mt={8}>
        <Text size="16px" fw={500} lh="20px" c="var(--content-secondary)">
          1 {coinSymbol} = {formatPrice(rate)} {currency}
        </Text>
        <UnstyledButton
          onClick={onRefresh}
          disabled={isRefreshing}
          style={{ opacity: isRefreshing ? 0.5 : 1, cursor: 'pointer' }}
        >
          <RefreshIcon width={20} height={20} />
        </UnstyledButton>
      </Flex>
      <Text fz={14} lh="20px" fw={500} lts={0.14} c="var(--content-tertiary)">
        {tConverter('priceDescription', {
          coinName,
          symbol: coinSymbol,
          currency,
          price: `${currencySymbol}${formatPrice(rate)}`,
        })}
      </Text>
    </Flex>
  )
}
